import { useState } from 'react';
import { ResizeIcon } from '../../../../../assets/icons';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import ImageCrop from '../../../../../containers/ImageCrop';
import { useDispatch, useSelector } from '../../../../../store/store';
import { selectCompanyLogo } from '../../../../../store/workspace/selectors';
import { setCompanyLogoModal, setCroppedCompanyLogo } from '../../../../../store/workspace/slice';
import styles from './style.module.scss';

const fileTypes = ["JPEG", "JPG", "PNG"];

export default function UploadCompanyLogo() {
    const dispatch = useDispatch();
    const companyLogo = useSelector(selectCompanyLogo);
    const [croppedImage, setCroppedImage] = useState<string | null>(null);

    return (
        <Modal
            size='md'
            icon={<ResizeIcon />}
            title='Drag to reposition'
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setCompanyLogoModal(false))}
        >
            <span>Company logo</span>
            <ImageCrop
                imageSrc={companyLogo}
                croppedImage={croppedImage}
                setCroppedImage={setCroppedImage}
            />
        </Modal>
    )
}
